<template>
  <div class="p-4 bg-white rounded-lg h-100">
    <ReportCharts
      :urls="urls"
      :mandatory-filter="[
        {
          name: 'report_date_month_range',
          title: 'Date range',
          valueFieldName: '.select',
        },
      ]"
    ></ReportCharts>
  </div>
</template>

<script>
import ReportCharts from "@/own/components/reports/ReportCharts";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
export default {
  name: "WonCustomerPerMonth",
  data: () => ({
    urls: {
      data_url: "/reports/reportSalesWonCustomerPerMonth",
      show_url: "/reports/reportSalesWonCustomerPerMonth/show",
    },
  }),
  components: { ReportCharts },

  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
  },
};
</script>
